// extracted by mini-css-extract-plugin
module.exports = {"formulario":"styles_formulario__TzS_h","campo":"styles_campo__ndqRi"};